import { render, staticRenderFns } from "./PlannedLevelFeatures.vue?vue&type=template&id=60198bbc&scoped=true&"
import script from "./PlannedLevelFeatures.vue?vue&type=script&lang=js&"
export * from "./PlannedLevelFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60198bbc",
  null
  
)

export default component.exports